import { MMKV } from "react-native-mmkv";
// import AsyncStorage from "@react-native-async-storage/async-storage";
import * as SecureStore from "expo-secure-store";
import { createContext, PropsWithChildren } from "react";

export type StorageContextProps = {
  saveFast: (key: NotString<string>, value: string | number | boolean) => void;
  saveSecure: (key: NotString<string>, value: string) => Promise<void>;
  getItem: (key: NotString<string>) => any;
  getString: (key: NotString<string>) => string | undefined;
  getNumber: (key: NotString<string>) => number | undefined;
  getBoolean: (key: NotString<string>) => boolean | undefined;
  removeItem: (key: string) => void;
};

type Forbidden = "key";
type NotString<T extends string> = T extends Forbidden ? never : T;

export const StorageContext = createContext<StorageContextProps | undefined>(undefined);

export function StorageProvider({ children }: PropsWithChildren) {
  const mmkv = new MMKV();

  const saveFast = async (key: NotString<string>, value: string | number | boolean) => {
    mmkv.set(key, value);
  };
  const removeItem = (key: string) => mmkv.delete(key);

  const saveSecure = async (key: NotString<string>, value: string) => {
    await SecureStore.setItemAsync(key, value);
  };

  const getNumber = (key: NotString<string>) => mmkv.getNumber(key);

  const getBoolean = (key: NotString<string>) => mmkv.getBoolean(key);

  const getString = (key: NotString<string>) => mmkv.getString(key);

  const getItem = (key: NotString<string>) => {
    const fromFast = mmkv.getString(key);
    if (fromFast !== undefined) return fromFast;
    // TODO: Improve fallback to secure.
    // const fromSecure = SecureStore.getItemAsync(key);
    // if (fromSecure !== null) return fromSecure;
    // return AsyncStorage.getItem(key); // last-resort fallback
  };
  return (
    <StorageContext.Provider value={{ saveFast, saveSecure, getItem, removeItem, getNumber, getBoolean, getString }}>
      {children}
    </StorageContext.Provider>
  );
}
